/* eslint-disable no-nested-ternary */
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { Grid, CircularProgress } from '@mui/material';
import { Header } from '../../../../pricing-simulator/types/generic-table.model';

export default function getColumnForPriceThreshold(
  columnData: Header,
  isDisplayHeader?: boolean
) {
  // style for DT column
  const dtColumnStyle = {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };
  return {
    accessorKey: columnData.parent.parent_field,
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order,

    cell: (info) => {

      const value = info.getValue();

      return (
        <div style={dtColumnStyle}>
          <CircularProgress
            size={20}
            sx={{ color: '#FD7622' }}
            variant='determinate'
            value={value}
          />
          <div>{value} %</div>
        </div>
      );
    },

    meta: {
      className: ''
    },
    header: () => (
      <Grid container alignItems='center' flexDirection='column'>
        <Grid
          item
          xs='auto'
          container
          alignItems='center'
          className='change-text'
        >
          {isDisplayHeader ? (
            <Grid item sx={{ cursor: 'pointer' }}>
              <span id='dt-header'>{columnData.parent.alias}</span>
              {getHeaderName(columnData)}
            </Grid>
          ) : null}
        </Grid>
      </Grid>
    )
  };
}
